var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notifiction",class:[_vm.placement, _vm.type, { visible: _vm.visible }]},[_c('div',{staticClass:"content"},[(_vm.header)?_c('div',{staticClass:"header"},[_vm._v(_vm._s(_vm.header))]):_vm._e(),(_vm.text)?_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }